<template>
    <ui-select-v3
        v-model="selected"
        :label="label"
        :data.sync="options"
        :loading="loader"
        :disabled="disabled"
        :return-value="returnValue"
        :text-items="['product']"
        :design="design"
        :cancel-event="cancelEvent"
        ajax-search
        search-event="customer"
        item-label="label"
        stage-status
        cards
        subtitle="Empreendimento não selecionado"
		:isIframe="isIframe"
    />
</template>

<script>
	import { uiSelectV3 } from '@/components/ui/form'
	import { deal } from '@/services/axios'
	import { mapGetters } from 'vuex'
	import helpers from '@/mixins/helpers'

	import axios from 'axios'

	const defaultParamsForDealSearch = {
		sortBy: { value: 'updated_at', dir: 'desc' },
		search: '',
		page: 1,
		perPage: 50,
		filter: [
			{
				name: 'team_id',
				value: null,
			},
			{
				name: 'manager_id',
				value: null,
			},
			{
				name: 'broker_id',
				value: null,
			},
			{
				name: 'id',
				value: null,
			}
		],
	}

	export default {
		name: 'ui-deal-selector',

		components: { uiSelectV3 },

		mixins: [helpers],

		props: {
			value: {
				type: null,
				required: true
			},
			data: {
				type: [Object, Array],
				required: false,
				default: () => {
					return {}
				},
			},
			label: {
				type: String,
				required: false,
				default: 'Cliente:',
			},
			disabled: {
				type: Boolean,
				required: false,
				default: false,
			},
			returnValue: {
				type: String,
				required: false,
				default: 'value',
			},
			design: {
				type: String,
				required: false,
				default: 'mgb-15 br-default',
			},
			/**
			 * Define o evento que vai ser escutado para limpar o uiSelect2
			 */
			cancelEvent: {
				type: String,
				required: false,
				default: ''
			},
			isIframe: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				selected: null,
				loader: false,
				options: [],
				page: 1,
				totalPages: 1,
				cancelToken: null
			}
		},

		computed: {
			...mapGetters('auth', {
				user: 'getUser',
			}),
			/**
			 * Computed property que verifica se o usuário logado é um supervisor
			 */
			isSupervisor() {
				return this.user.user_group === 'supervisor'
			},
			/**
			 * Computed property que verifica se o usuário logado é um gerente
			 */
			isManager() {
				return this.user.user_group === 'manager'
			}
		},

		watch: {
			async data(newVal) {
				if (newVal) {
					await this.loadData('a')
				}
			},
			value: {
				handler(newVal) {
					if (!newVal) this.resetData()
				},

				deep: true,
			},
			selected: {
				handler(newVal) {
					this.$emit('input', newVal)
				},

				deep: true,
			}
		},

		mounted() {
			this.$root.$on('select-v2-ajax-search-customer', async (data, clear) => {
				if (!data.nextPage) {
					this.page = 1
					this.totalPages = 1
					this.resetData()

				} else {
					if (this.page < this.totalPages) {
						this.page += 1

					} else {
						return
					}
				}

				if (this.cancelToken) this.cancelToken.cancel()
				this.cancelToken = axios.CancelToken.source()
				await this.loadData(data.search, clear)
			})

			this.$root.$on('deal-selector', async (data, search = true) => {
				// Search with customer name
				if (search) await this.loadData(data.customer_name)

				// Select the current data
				let name = data.customer_name || data.customer.name || null
				this.$root.$emit('set-input-search-select-v3', name, true)
				this.selected = data
			})
		},

		beforeDestroy() {
			this.$root.$off('select-v2-ajax-search-customer')
			this.$root.$off('deal-selector')
		},

		methods: {
			resetData() {
				// Clear the selected data
				this.selected = []
				this.$emit('input', [])

				// Clear options
				this.options = []
			},

			async loadData(search, clear) {
				if(clear) return this.resetData()

				if (!this.data) this.options = []

				let params = { ...defaultParamsForDealSearch }
				params.search = search
				params.page = this.page

				params.filter[0].value = null
				params.filter[1].value = null
				params.filter[2].value = this.user.user_group === 'broker' ? this.user.broker_id : null

				if (this.user.user_group !== 'broker') {
					switch (this.data.group) {
						case 'broker':
							params.filter[2].value = this.data.broker_id
							break
						case 'manager':
							params.filter[1].value = this.data.manager_id
							break
						case 'supervisor':
							params.filter[0].value = this.data.supervisor_team_id
					}
				}

				try {
					this.loader = true

					const token = this.cancelToken ? this.cancelToken.token : null
					const customers = (await deal.dataTable(params, token)).data

					this.totalPages = Math.floor(customers.recordsFiltered / params.perPage)
					const formattedOptions = customers.data.map((e) => {
						return {
							label: e.id + ' - ' + e.customer_name,
							value: e.id,
							product: e.product_name || '',
							...e,
						}
					})
					this.options = [...this.options, ...formattedOptions]

					this.loader = false

				} catch (e) {
					this.loader = false
					console.error(e)
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
